import { Box, Typography, Container } from "@mui/material";
import { clients } from "../data/clients";

export default function HeroSection() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage:
          "url(https://images.unsplash.com/photo-1492724441997-5dc865305da7)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to right, rgba(11,15,26,0.9), rgba(11,15,26,0.6))",
        }}
      />

      <Container
        sx={{
          position: "relative",
          zIndex: 2,
          pt: 20,
          pb: 8,
          maxWidth: "md",
          color: "#fff",
        }}
      >
        <Typography variant="h2" fontWeight={700} gutterBottom>
          Transforming Businesses Through Digital Innovation
        </Typography>

        <Typography variant="h4" gutterBottom>
          Nerdshub partners with forward-thinking businesses to drive growth
          through cutting-edge digital technologies.
        </Typography>

        <Typography variant="h6" color="grey.400" sx={{ mb: 6 }}>
          We work closely with you to understand your challenges, processes, and
          vision.
        </Typography>

        {/* OUR CLIENTS */}
        <Typography
          variant="h5"
          align="center"
          sx={{
            mb: 3,
            letterSpacing: 2,
            fontWeight: 600,
          }}
        >
          OUR CLIENTS
        </Typography>

        {/* LOGO SCROLLER */}
        <Box sx={{ overflow: "hidden", width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              width: "max-content",
              animation: "scroll 50s linear infinite",
              "@keyframes scroll": {
                "0%": { transform: "translateX(0)" },
                "100%": { transform: "translateX(-50%)" },
              },
            }}
          >
            {[...clients, ...clients].map((logo, index) => (
              <Box
                key={index}
                component="img"
                src={`/client-png/${logo}`}
                alt="Client Logo"
                sx={{
                  height: 200,
                  mx: 4,
                  px: 3,
                  py: 2,

                  /* Rounded corners */
                  borderRadius: "16px",

                  /* Light bend / blend effect */
                  backgroundColor: "rgba(255,255,255,0.08)",
                  backdropFilter: "blur(3px)",

                  /* Soft glow */
                  boxShadow: "0 0 18px rgba(255,255,255,0.18)",

                  /* Image tone */
                  opacity: 0.85,
                  filter: "brightness(1.1)",

                  transition: "all 0.35s ease",

                  "&:hover": {
                    opacity: 1,
                    boxShadow: "0 0 28px rgba(255,255,255,0.35)",
                    transform: "scale(1.05)",
                  },
                }}
              />
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
